import { ApiModel }          from '../../app-lite/api/models/api.model';

export class ManageSystemActivityCtrl {
  beginDate    = '*';
  endDate      = '*';
  timeDuration = 1;

  constructor (
    private $scope : any,
    private $window: ng.IWindowService,
    private API    : ApiModel,
  ) {}

  print ( type : 'csv' | 'pdf') : void {
    const url = `${ this.API.url }/reports/jasper_system_activity_logs/${ type }/${ this.timeDuration || 1 }/${ this.$scope.company.id }/${ this.beginDate }/${ this.endDate }${ type === 'pdf' ? '.pdf' : '' }`;

    this.$window.open(url, '_blank');
  }
}
